import { Auth } from 'aws-amplify';
import config from '../config/application';
import { apiCall } from './common/oauth.service';

//url
const loginUrl = 'login';
const logoutUrl = 'logout';
const registerUrl = 'register_user';
const registerRole = 'save';
const updateState = 'update_state';

class LoginService {
  login = async () => {
    let user = await Auth.currentAuthenticatedUser();
    if (user === undefined) {
      return null;
    } else {
      sessionStorage.setItem('username', user.getUsername());
      sessionStorage.setItem('name', user.getUsername());
      return user;
    }
  }

  loginCognito = async (email, password) => {
    await Auth.signIn(email, password);
    let user = await Auth.currentAuthenticatedUser();
    if (user === undefined) {
      return null;
    } else {
      sessionStorage.setItem('username', user.getUsername());
      sessionStorage.setItem('name', user.getUsername());
      return user;
    }
  }

  getDataUser = (jsonLogin) => {
    const url = `${config.data.security.login.url}/${loginUrl}`;
    return apiCall("post",url, jsonLogin);
  }
  logout = (jsonLogout) => {
    const url = `${config.data.security.login.url}/${logoutUrl}`;
    return apiCall("post",url, jsonLogout);
  }
  registerUser = (jsonLogin) => {
    const url = `${config.data.security.login.url}/${registerUrl}`;
    return apiCall("post",url, jsonLogin);
  }

  registerRole = (jsonUserRole) => {
    const url = `${config.data.security.assingnRole.url}${registerRole}`;
    return apiCall("post",url, jsonUserRole);
  }

  updateStatus = (jsonUserRole) => {
    const url = `${config.data.security.login.url}/${updateState}`;
    return apiCall("put",url, jsonUserRole);
  }

}
export default new LoginService(); 